import { render, staticRenderFns } from "./DoctorBankDetail.vue?vue&type=template&id=b65d72de&"
import script from "./DoctorBankDetail.vue?vue&type=script&lang=js&"
export * from "./DoctorBankDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports